<template>
  <div style="padding: 0 10px">
    <div style="text-align: left">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        @keydown.native.enter="submit"
      >
        <el-form-item label="业务单号">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.bizOrderNo"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="操作员工名称">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.operatorName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="系统单号">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.systemOrderNo"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select
            placeholder="操作类型"
            @change="submit"
            v-model="formInline.bizNodeType"
          >
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="波次" value="WMS_WAVE"></el-option>
            <el-option label="入库" value="WMS_INBOUND"></el-option>
            <el-option label="打包" value="WMS_PACK"></el-option>
            <el-option label="审单" value="WMS_REVIEW"></el-option>
            <el-option label="移库" value="WMS_MOVE"></el-option>
            <el-option label="拣货" value="WMS_PICK"></el-option>
            <el-option label="发货" value="WMS_DELIVERY"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间">
          <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
            @change="timeChange" end-placeholder="结束日期"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="" type="primary" @click="submit">查询</el-button>
          <el-button style="margin-left: 10px" @click="rest">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall"
      :hasHeader="false"
      :isPagination="query"
    >
    </WmsTable>
  </div>
</template>

<script>
import { operateLog } from '@/apis/inHouse'
import WmsTable from "@/components/WmsTable";
import { columns } from './data'
import moment from "moment"
export default {
  name: "log",
  components: {
    WmsTable
  },
  data() {
    return {
      formInline: {
        bizNodeType: '',
        systemOrderNo: '',
        operatorName: '',
        bizOrderNo: ''
      },
      date: '',
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      columns,
      dataSource: []
    };
  },
  mounted() {
    this.getList()
  },
  beforeUnmount() {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    submit(){
      this.query.current = 1;
      this.getList()
    },
    rest(){
      this.date = '';
      Object.keys(this.formInline).forEach((i) => {
        this.formInline[i] = '';
      });
      this.query = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.getList();
    },
    timeChange: function (val) {
      if (!val) {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
        return;
      }
      this.formInline.startTime = moment(val[0]).format("YYYY-MM-DD");
      this.formInline.endTime = moment(val[1]).format("YYYY-MM-DD");
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    getList(){
      operateLog({
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
        warehouse: this.$store.getters.getWareCode,
      }).then((res) => {
        this.dataSource = res.data.records
        this.query.total = res.data.total
      });
    }
  },
};
</script>
<style lang="less" scoped>
</style>